// src/components/CardProducto.js
import React from "react";

export default function CardProducto({ producto }) {
  return (
    <div className="border rounded-lg shadow-md p-4 max-w-xs hover:shadow-xl transition-shadow duration-300">
      <img
        src={producto.imagen}
        alt={producto.nombre}
        className="h-40 w-full object-contain mb-4"
      />
      <h3 className="font-semibold text-lg mb-2">{producto.nombre}</h3>
      <p className="text-gray-700 mb-2">{producto.descripcion}</p>
      <p className="font-bold text-blue-600">${producto.precio.toFixed(2)}</p>
    </div>
  );
}
